import React from 'react';
import { Modal, Box, Paper, Typography, Grid, Button } from '@mui/material';

interface HistoricoItem {
  changeDate: string;
  changeType: string;
  changedBy: string;
  descricaoAlteracoes: string;
}

interface ModalHistoricoProdutoProps {
  open: boolean;
  onClose: () => void;
  historico: HistoricoItem[];
  produto: any;
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  width: { xs: "95vw", sm: 600 },
  transform: 'translate(-50%, -50%)',
  maxWidth: '90vw',
  maxHeight: '90vh',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: { xs: 2, sm: 4 },
  overflowY: 'auto',
};

const ModalHistoricoProduto: React.FC<ModalHistoricoProdutoProps> = ({ open, onClose, historico, produto }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h6" gutterBottom>
          Histórico do Produto {produto?.descricao ? `- ${produto.descricao}` : ''}
        </Typography>
        <Paper style={{ padding: 16, marginBottom: 16, maxHeight: 400, overflowY: 'auto' }}>
          {historico && historico.length > 0 ? (
            historico.map((item, idx) => (
              <Box key={idx} mb={2} p={1} borderBottom={1} borderColor="#eee">
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2"><b>Data:</b> {new Date(item.changeDate).toLocaleString()}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2"><b>Tipo:</b> {item.changeType}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2"><b>Usuário:</b> {item.changedBy}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body2"><b>Alterações:</b> {item.descricaoAlteracoes}</Typography>
                  </Grid>
                </Grid>
              </Box>
            ))
          ) : (
            <Typography variant="body2">Nenhum histórico encontrado.</Typography>
          )}
        </Paper>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button variant="contained" onClick={onClose}>Fechar</Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalHistoricoProduto; 